import React from 'react';
import { Typography } from '@mui/material';
import TransactionAllocator, {
  Transaction,
} from 'components/TransactionAllocator';
import { CurrencyCode, FxDataFeed } from 'further-types/lp/vehicle';
import AppAccordion from 'components/AppAccordion';
import { numberToCurrencyString } from 'further-ui/utils';
import Row from 'components/Layout/Row';
import { useFormContext } from 'react-hook-form';
import { PartnerTransfersFormValues } from '../hooks/usePartnerTransfersForm';
import { sumBy } from 'lodash';

type FeeTransactionAllocatorProps = {
  feeId: string;
  feeName: string;
  transactions: Array<Transaction>;
  transactionTypeOptions: Array<{ label: string; value: string | null }>;
  vehicle: {
    _id: string;
    baseCurrency: CurrencyCode;
    fxDataFeed: FxDataFeed;
  };
  savedTransactions?: Record<string, Array<Transaction>>;
};

const FeeTransactionAllocator: React.FC<FeeTransactionAllocatorProps> = ({
  feeId,
  feeName,
  transactions,
  transactionTypeOptions,
  vehicle,
  savedTransactions,
}) => {
  const { setValue, getValues } = useFormContext<PartnerTransfersFormValues>();

  const currentTransactions = savedTransactions?.[feeId] ?? transactions;

  const onTransactionChange = (updatedTransactions: Array<Transaction>) => {
    const existingTransactions = getValues('feeTransactions') ?? {};

    setValue('feeTransactions', {
      ...(existingTransactions ?? {}),
      [feeId]: updatedTransactions.map((t) => ({
        ...t,
        id: t.id?.toString(),
        amountExVatLcy: t.amountExVatLcy ?? 0,
        amountIncVatLcy: t.amountIncVatLcy ?? 0,
      })),
    });
  };

  const totalAmount = sumBy(currentTransactions, 'amountIncVatTcy');

  return (
    <AppAccordion title={feeName} defaultExpanded>
      <AppAccordion.Summary>
        <Row>
          <Typography>
            {numberToCurrencyString(totalAmount, {
              currency: vehicle.baseCurrency,
            })}
          </Typography>
        </Row>
      </AppAccordion.Summary>
      <AppAccordion.Content>
        <TransactionAllocator
          transactionTypeOptions={transactionTypeOptions}
          transactions={currentTransactions}
          onChange={onTransactionChange}
          transactionCurrency={vehicle.baseCurrency}
          fxRate={null}
          vehicle={vehicle}
        />
      </AppAccordion.Content>
    </AppAccordion>
  );
};

export default FeeTransactionAllocator;
